import constants from '@/app-configs/constants'

export default [
  {
    title: 'Payments',
    icon: 'ArchiveIcon',
    action: constants.action.permissionUserView,
    resource: constants.resource.user,
    children: [
      {
        title: 'DEBTIA_PAYMENTS',
        route: 'payments-list',
        icon: 'AlignJustifyIcon',
        action: constants.action.permissionUserView,
        resource: constants.resource.user,
      },
      {
        title: 'Admin Settings',
        route: 'payments-admin-settings',
        action: constants.action.permissionUserView,
        resource: constants.resource.user,
      },
    ],
  },
]
